<div mat-dialog-title>
  <div class="dialog-caption">
    {{holdingType?.id ? 'Edit' : 'Create'}} Ticker
  </div>

  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content>
  <app-holding-type-form #holdingTypeFormComponent
                         [holdingType]="holdingType"
                         (saved)="dialogRef.close()">
  </app-holding-type-form>
</div>

<div mat-dialog-actions class="align-h-space-between">
  <button class="btn basic" mat-dialog-close>Cancel</button>
  <button type="submit" class="btn primary" [appFormSubmit]="holdingTypeFormComponent">Save</button>
</div>
